import { Route } from '@angular/router';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import {
    authenticatedAuthRoutes,
    guestAuthRoutes,
} from 'app/modules/auth/auth.routes';

import { TestingComponent } from './components/testing/testing.component';
import { LayoutIndexComponent } from './layout/core/layout-index/layout-index.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
    // Redirect empty path to '/example'
    { path: '', pathMatch: 'full', redirectTo: 'app' },

    // Redirect signed-in user to the '/main'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    { path: 'dashboard', pathMatch: 'full', redirectTo: 'app' },

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutIndexComponent,
        data: {
            layout: 'empty',
        },
        children: [
            ...guestAuthRoutes,
            { path: 'testing', component: TestingComponent },
        ],
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutIndexComponent,
        data: {
            layout: 'empty',
        },
        children: [...authenticatedAuthRoutes],
    },

    // Landing routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutIndexComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'home',
                loadChildren: () =>
                    import('app/modules/landing/home/home.routes'),
            },
        ],
    },

    // Sho Management Routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutIndexComponent,
        // resolve: {
        //     initialData: initialDataResolver
        // },
        data: {
            layout: 'sho',
        },
        children: [
            {
                path: 'app',
                loadChildren: () =>
                    import('app/modules/sho_management_pro/sho.routes'),
            },
        ],
    },
];
